import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { getLocationQuery } from 'utils/helpers';
import * as actions from './actions';
import { authCurrentUser, resetPasword } from '../auth/actions';
import { setLoading } from '../loading/actions';

let lastHref = decodeURIComponent(window.location.pathname);
const setup = async ({ dispatch, history }) => {
  const { pathname } = history.location;
  if (pathname === '/handle-oauth-login') {
    dispatch(setLoading({ key: 'app', value: false }));
  } else if (pathname.split('/')[1] === 'reset') {
    dispatch(resetPasword(pathname));
  } else {
    dispatch(authCurrentUser());
  }
};

const setupHistory = ({ dispatch, history }) => {
  history.listen((location) => {
    if (lastHref !== location.pathname) {
      window.scrollTo(0, 0);
      lastHref = location.pathname;
    }

    dispatch(
      actions.updateState({
        locationPathname: location.pathname,
        locationQuery: getLocationQuery(location.search),
      })
    );
  });
};

export const useGlobalSubscriptions = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const params = { dispatch, history };

    setup(params);
    setupHistory(params);
  }, []);
};
